module.exports = __webpack_public_path__ + "img/0Q3A3001_L_Foamcore.2d4e4d12.jpg";